import { render, staticRenderFns } from "./SmzUserInProcedureSelect.vue?vue&type=template&id=2cb89c87&scoped=true"
import script from "./SmzUserInProcedureSelect.vue?vue&type=script&lang=js"
export * from "./SmzUserInProcedureSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb89c87",
  null
  
)

export default component.exports